export const boxStyle = {
  mt: 8,
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  position: 'sticky',
  bottom: 0,
  bg: 'white',
  zIndex: 10,
  py: 4,
  borderTop: '1px solid',
  borderColor: 'gray.100',
  marginTop: 'auto',
};

export const buttonStyle = {
  colorScheme: 'brand',
  width: '100%',
  size: 'lg',
};
